import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, Flame, Wrench, Snowflake, Factory } from "lucide-react";
import { ServiceCarousel } from "@/components/ServiceCarousel";

const Diensten = () => {
  // Placeholder images from Unsplash that match the context
  const cvImages = [
    "https://i.imgur.com/nVPks7B.jpeg",
    "https://i.imgur.com/ojN974G.jpeg",
    "https://i.imgur.com/xkkHmeI.jpeg",
  ];

  const aircoImages = [
    "https://i.imgur.com/ujkabYd.jpeg",
    "https://i.imgur.com/FaoH5p5.jpeg",
  ];

  const leidingImages = [
    "https://i.imgur.com/BWQ9zEx.jpeg",
    "https://i.imgur.com/xj6O8iX.jpeg",
    "https://i.imgur.com/E4TyhWl.jpeg",
    "https://i.imgur.com/lb8m3aP.jpeg",
    "https://i.imgur.com/9shseug.jpeg",
  ];

  const industrieImages = [
    "https://i.imgur.com/Ts3f1Fz.jpeg",
    "https://i.imgur.com/cMC1r9G.jpeg",
    "https://i.imgur.com/xxAi4ww.jpeg",
    "https://i.imgur.com/O9DBCar.jpeg",
    "https://i.imgur.com/ypGIbqM.jpeg",
  ];

  return (
    <div className="bg-slate-50 min-h-screen py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-4">Mijn Diensten</h1>
            <p className="text-lg text-slate-600">
              M Pomp Multiservice biedt een breed scala aan diensten voor particulieren en bedrijven.
            </p>
          </div>

          <div className="space-y-12">
            {/* CV-onderhoud, storingen en vervanging */}
            <div id="cv" className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 scroll-mt-24">
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="w-full lg:w-1/2">
                   <ServiceCarousel images={cvImages} className="h-[360px] md:h-[400px] w-full" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-amber-100 rounded-lg shrink-0">
                      <Flame className="h-6 w-6 text-amber-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">CV-onderhoud, storingen en vervanging</h2>
                  </div>
                  
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    Ik onderhoud uw cv-ketel volgens de voorschriften van de fabrikant en conform de normen van de Gasketelwet (BRL 6000-25).
                  </p>
                  <p className="text-slate-600 leading-relaxed">
                    Jaarlijks onderhoud en controle zorgen ervoor dat uw cv-ketel efficiënter werkt en een langere levensduur heeft.
                  </p>
                </div>
              </div>
            </div>

            {/* Airco-, koel- en vriesinstallaties */}
            <div id="airco" className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 scroll-mt-24">
               <div className="flex flex-col lg:flex-row gap-8">
                <div className="w-full lg:w-1/2">
                   <ServiceCarousel images={aircoImages} className="h-[360px] md:h-[400px] w-full" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-blue-100 rounded-lg shrink-0">
                      <Snowflake className="h-6 w-6 text-blue-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">Airco-, koel- en vriesinstallaties</h2>
                  </div>
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    Voor het plaatsen, repareren en onderhouden van uw airconditioning, koel- of vriesinstallatie bent u bij mij aan het juiste adres.
                  </p>
                  <div className="space-y-4">
                    <div className="flex gap-3">
                      <Check className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                      <p className="text-slate-600 leading-relaxed">
                        Alle werkzaamheden worden uitgevoerd conform de geldende regelgeving, waaronder de Europese F-gassenverordening (EU 2024/573).
                      </p>
                    </div>
                    <div className="flex gap-3">
                      <Check className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
                      <p className="text-slate-600 leading-relaxed">
                        Ook bij storingen kunt u rekenen op een snelle en vakkundige oplossing.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Leidingwerk */}
            <div id="leidingwerk" className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 scroll-mt-24">
               <div className="flex flex-col lg:flex-row gap-8">
                <div className="w-full lg:w-1/2">
                   <ServiceCarousel images={leidingImages} className="h-[360px] md:h-[400px] w-full" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-slate-100 rounded-lg shrink-0">
                      <Wrench className="h-6 w-6 text-slate-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">Leidingwerk</h2>
                  </div>
                  <p className="text-slate-600 mb-4 leading-relaxed font-medium">
                    Gespecialiseerd in leidingwerk.
                  </p>
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    Ik werk met alle diameters, diverse materialen en verschillende technieken. Leidingwerk wordt vakkundig aangelegd, aangepast of hersteld, met oog voor kwaliteit en duurzaamheid.
                  </p>
                  <p className="text-slate-600 leading-relaxed flex items-center gap-2">
                    <Check className="h-4 w-4 text-amber-500" />
                    Elke klus wordt zorgvuldig uitgevoerd met aandacht en een nette afwerking.
                  </p>
                </div>
              </div>
            </div>

             {/* Industrie en utiliteitsbouw */}
             <div id="industrie" className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 scroll-mt-24">
               <div className="flex flex-col lg:flex-row gap-8">
                <div className="w-full lg:w-1/2">
                   <ServiceCarousel images={industrieImages} className="h-[360px] md:h-[400px] w-full" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-teal-100 rounded-lg shrink-0">
                      <Factory className="h-6 w-6 text-teal-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">Industrie en utiliteitsbouw</h2>
                  </div>
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    Ik ben vertrouwd met werken in industriële en utiliteitsprojecten.
                  </p>
                  <div className="p-4 bg-slate-50 rounded-lg border-l-4 border-amber-500">
                    <p className="text-slate-700 leading-relaxed font-medium">
                      Veiligheid staat voorop: met een geldig VCA-certificaat werk ik volgens de geldende regels en procedures op elke locatie.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="mt-12 bg-amber-500 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Direct een vakman nodig?</h3>
            <p className="text-slate-900/80 mb-6">Neem contact op voor een vrijblijvende offerte of advies op maat.</p>
            <Button asChild size="lg" className="bg-slate-900 hover:bg-slate-800 text-white font-bold">
              <Link to="/contact">Neem Contact Op</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diensten;
